import {
  DELETE_REPORTS_REQUEST,
  DELETE_REPORTS_RESPONSE,
  DELETE_REPORTS_ERROR,
  OPEN_DELETE_REPORT_MODAL,
  CLOSE_DELETE_REPORT_MODAL,
  OPEN_BULK_DELETE_REPORT_MODAL,
} from './actionTypes';

// import type { DeleteReportRequest } from './types';

// Handles both single report and bulk report deletion
export function deleteReportRequest(deleteReportData /*: DeleteReportRequest */) {
  return {
    type: DELETE_REPORTS_REQUEST,
    deleteReportData,
  };
}

export function deleteReportResponse(reportName /*: string */) {
  return {
    type: DELETE_REPORTS_RESPONSE,
    reportName,
  };
}

export function deleteReportError(error, reportName /*: string */) {
  return {
    type: DELETE_REPORTS_ERROR,
    error,
    reportName,
  };
}

export function openDeleteReportModal(id /* ?: number */) {
  return {
    type: OPEN_DELETE_REPORT_MODAL,
    deleteReportId: id,
    openReportsTableModal: true,
  };
}

export function closeDeleteReportModal() {
  return {
    type: CLOSE_DELETE_REPORT_MODAL,
    openReportsTableModal: false,
  };
}

export function openBulkDeleteReportModal(reportIds /* ?: number[] */) {
  return {
    type: OPEN_BULK_DELETE_REPORT_MODAL,
    reportIds,
  };
}
